// extracted by mini-css-extract-plugin
export var content = "_da-3";
export var list = "_da-4";
export var settingsContent = "_da-7";
export var settingsPanel = "_da-8";
export var state = "_da-6";
export var triggerBadge = "_da-2";
export var triggerButton = "_da-1";
export var triggerShell = "_da-0";
export var unreadDot = "_da-5";